import {
  usePathBrandToken,
  usePathProductToken,
} from "@faire/deprecated-retailer-visitor-shared/views/reviews/pathUtils";
import { useReviewsDisplayView } from "@faire/deprecated-retailer-visitor-shared/views/reviews/useReviewsDisplayView";
import { useViewportValue } from "@faire/deprecated-retailer-visitor-shared/views/reviews/useViewportValue";
import { useRetailer } from "@faire/marketplace-lib/stores/retailer/useRetailer";
import { trackBrandReviewsLinkScrollToReviewsDisplayClick } from "@faire/web-api--source/events/brandReviews/click/linkScrollToReviewsDisplay";
import { trackEvent } from "@faire/web/common/trackEvent";
import { useCallback } from "react";

/**
 * Returns a callback that tracks a legacy event and a Pete event
 *
 * To be used when user clicks on the reviews link at the top of PDP and Brand page
 */
export const useClickToScrollToReviewsDisplayTracking = () => {
  const { retailerToken = "" } = useRetailer();
  const productToken = usePathProductToken();
  const brandToken = usePathBrandToken();
  const view = useReviewsDisplayView();
  const viewport = useViewportValue();

  const trackPeteClickEvent = useCallback(() => {
    trackBrandReviewsLinkScrollToReviewsDisplayClick(
      view,
      viewport,
      retailerToken,
      productToken,
      brandToken
    );
  }, [view, viewport, retailerToken, productToken, brandToken]);

  const trackLegacyClickEvent = useCallback(() => {
    if (productToken) {
      void trackEvent(
        `retailer/${retailerToken}/product/${productToken}/see-reviews/clicked`
      );
    } else if (brandToken) {
      void trackEvent(
        `brand/${brandToken}/retailer/${retailerToken}/see-reviews/clicked`
      );
    }
  }, [productToken, retailerToken, brandToken]);

  return useCallback(() => {
    trackPeteClickEvent();
    trackLegacyClickEvent();
  }, [trackLegacyClickEvent, trackPeteClickEvent]);
};
